import InfoService from '@/api/admin/info.service'

export default {
  state: {
    table: {
      rows: [],
      searchTerm: '',
    },
  },
  getters: {
    getSectionGroup: state => state.table,
  },
  actions: {
    async getSectionGroup({ commit }, id) {
      const sectionGroup = await InfoService.getSectionGroup(id)
      commit('SET_SECTION_GROUP', sectionGroup.sectionModelList)
    },
  },
  mutations: {
    SET_SECTION_GROUP(state, sectionGroup) {
      state.table.rows = sectionGroup
    },
  },
}
